module.exports = __webpack_public_path__ + "static/media/video.1eb28304.jpg";